export default __webpack_public_path__ + "static/media/stats.f2dceb6c.png";